// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "meta_ad_service".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { adLinkSourceValues } from '@borradh-workspace/labels';
/** Response atom for the "meta_ad_service" table (1:1 with a DB row, on the wire). */
export const metaAdServiceAtomSchema = z.object({
    id: z.string(),
    metaAdId: z.string(),
    serviceId: z.string(),
    linkSource: z.enum(adLinkSourceValues),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=metaAdService.js.map